import type { CityConfig } from "../city-template/types";

export const tellurideConfig: CityConfig = {
  city: "Telluride",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "telluride",
  route: "/cities/telluride",
  title: "Emergency & Expedited Passport Telluride CO | Same-Day San Miguel County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Telluride, Colorado — as fast as 24 hours. Same-day courier processing for Telluride, Mountain Village, Ridgway, Ouray, and all San Miguel County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Telluride, CO",
  heroSubtitle: "Last-minute trip to the Swiss Alps and your passport needs renewal? Film festival coming up and you need international travel documents fast? We help Telluride residents — from Mountain Village homeowners to box canyon locals to San Miguel County families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Telluride%20Colorado%20scenic%20mountain%20town%20nestled%20in%20a%20dramatic%20box%20canyon%20with%20towering%20snow%20dusted%20peaks%20and%20Bridal%20Veil%20Falls%20cascading%20down%20the%20cliff%20face%2C%20historic%20Main%20Street%20with%20colorful%20Victorian%20era%20buildings%20and%20boutique%20shops%2C%20the%20free%20gondola%20connecting%20Telluride%20to%20Mountain%20Village%2C%20bright%20blue%20sky%20with%20fluffy%20clouds%2C%20crisp%20alpine%20lighting%20at%20golden%20hour%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20perspective&width=1800&height=700&seq=telluride-hero-001&orientation=landscape",
  heroImageAlt: "Telluride Colorado box canyon with Bridal Veil Falls and historic Main Street",
  geoPosition: "37.9375;-107.8123",
  geoPlacename: "Telluride, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S. Vaughn Way, Aurora, CO 80014",
    distance: "Approximately 330 miles northeast — about 6 hours via US-550 and I-70",
  },
  nearbyCitiesZips: [
    { name: "Telluride", zips: "81435" },
    { name: "Mountain Village", zips: "81435" },
    { name: "Placerville", zips: "81430" },
    { name: "Norwood", zips: "81423" },
    { name: "Ridgway", zips: "81432" },
    { name: "Ouray", zips: "81427" },
    { name: "Silverton", zips: "81433" },
    { name: "Dolores", zips: "81323" },
    { name: "Mancos", zips: "81328" },
    { name: "Cortez", zips: "81321" },
    { name: "Montrose", zips: "81401, 81402, 81403" },
    { name: "Delta", zips: "81416" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Telluride international departures via TEX or MTJ" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive 6 hours to Denver" },
    { icon: "ri-flight-takeoff-line", title: "TEX & MTJ Airport Service", desc: "Same-day courier for Telluride Regional and Montrose Regional airports" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in the San Miguel region" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Grand Junction, CO", route: "/cities/grand-junction" },
    { name: "Fast passport renewal in San Miguel County", route: "/cities/telluride" },
    { name: "Urgent passport services for Mountain Village", route: "/cities/telluride" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Ridgway and Ouray", route: "/cities/telluride" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Telluride remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Telluride's remote location — 330 miles from the Denver Passport Agency via US-550 and I-70 — makes our courier service essential. There is simply no practical way to drive to Denver and back in a day from Telluride.",
  fpcOfficeAddress: "3151 S. Vaughn Way, Aurora, CO 80014",
  fpcOfficeDistance: "Serving all of San Miguel County and the surrounding Western Slope communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Telluride and the San Miguel River Valley. From the historic box canyon and Main Street to Mountain Village and the ski resort, from Lawson Hill to the residential areas of West Telluride — we serve every corner of Telluride and the surrounding mountain region.",
  nearbyCitiesIntro: "We serve Telluride and all nearby communities including Mountain Village, Placerville, Norwood, Ridgway, Ouray, Silverton, Dolores, Mancos, Cortez, and Montrose. We also serve the entire Uncompahgre Valley and Four Corners region.",
  howItWorksIntro: "Most Telluride travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — there's simply no practical way to drive 330 miles to Denver from Telluride.",
  mistakesIntro: "Telluride is one of Colorado's most remote and exclusive resort communities. The 6-hour drive to Denver combined with limited local services creates unique passport challenges. Here are the most common mistakes we see from Telluride-area travelers.",
  testimonialsIntro: "Telluride travelers — from winter ski vacationers to summer festival attendees to year-round San Miguel County residents — trust us when their departure is days away and Denver is 6 hours away.",
  faqIntro: "Have questions about expedited passports in Telluride, CO? Here are the most common ones we hear from San Miguel County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (6+ hours each way)", "Impractical for Telluride residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Telluride", "Perfect for international ski trips and European vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Telluride travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service for one of Colorado's most remote resort towns.",
      bullets: ["24–48 hour turnaround available", "TEX and MTJ airport departure support", "European ski destination expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Telluride adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your San Miguel County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Telluride residents and San Miguel County families — including seasonal resort staff and new residents.",
      bullets: ["Acceptance facility scheduling in Telluride or Montrose", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Telluride residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Telluride and San Miguel County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Telluride and San Miguel County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Telluride CO", description: "Urgent passport processing for Telluride Colorado travelers with immediate departure needs from TEX or MTJ." },
    { name: "Expedited Passport Renewal Telluride CO", description: "Fast passport renewal for Telluride Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Telluride CO", description: "New passport application services for Telluride Colorado residents applying for their first passport." },
    { name: "Child Passport Telluride CO", description: "Minor passport services for Telluride Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "David C.",
      location: "Mountain Village, CO",
      rating: 5,
      text: "Private jet to Zermatt departing in 3 days and my passport was expiring. Fast Passport Center got my renewal done in 2 days. Living in Telluride, driving to Denver is a 12-hour round trip — there's no other way to do this.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer H.",
      location: "Telluride, CO — Box Canyon",
      rating: 5,
      text: "Family trip to Patagonia over the holidays. Two passports needed renewal and my daughter needed her first. Done in 5 days. The courier service is a lifesaver when you live at the end of the road.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tom R.",
      location: "Placerville, CO",
      rating: 5,
      text: "Business trip to Dubai with 5 days notice. Fast Passport Center got it done in 3 days. From Telluride, there's no realistic way to visit a passport agency in person — this service is essential.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda L.",
      location: "Telluride, CO — Lawson Hill",
      rating: 5,
      text: "Lost my passport during a move and had a trip to Italy booked for the Telluride Film Festival off-season. Replaced in 48 hours. Incredible customer service and communication throughout.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "tel-1",
      name: "Telluride Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 S Willow St",
      city: "Telluride",
      state: "CO",
      zip: "81435",
      phone: "(970) 728-3906",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Downtown Telluride, near Colorado Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Telluride acceptance facility. Very limited hours — one of Colorado's smallest passport acceptance locations. Appointments required, book 3–4 weeks ahead during ski and festival seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "tel-2",
      name: "Mountain Village Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "113 Lost Creek Ln",
      city: "Mountain Village",
      state: "CO",
      zip: "81435",
      phone: "(970) 728-5681",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Mountain Village, accessible via the free gondola from Telluride",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Mountain Village residents. Extremely limited hours. Small facility with limited appointment slots.",
      icon: "ri-mail-line",
    },
    {
      id: "tel-3",
      name: "Montrose Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "321 S 1st St",
      city: "Montrose",
      state: "CO",
      zip: "81401",
      phone: "(970) 249-4244",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Montrose, approximately 65 miles north of Telluride via CO-145 and US-550",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in the region with the best appointment availability. Approximately 1.5-hour drive from Telluride but worth it for faster scheduling.",
      icon: "ri-mail-line",
    },
    {
      id: "tel-4",
      name: "San Miguel County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "305 W Colorado Ave",
      city: "Telluride",
      state: "CO",
      zip: "81435",
      phone: "(970) 728-3954",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Telluride downtown, near the San Miguel County Courthouse",
      website: "https://www.sanmiguelcountyco.gov/",
      websiteLabel: "San Miguel County Clerk",
      notes: "County clerk passport acceptance. May have better availability than the post office during peak seasons. Convenient downtown location.",
      icon: "ri-government-line",
    },
    {
      id: "tel-5",
      name: "Ridgway Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 N Lena St",
      city: "Ridgway",
      state: "CO",
      zip: "81432",
      phone: "(970) 626-5491",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ridgway, approximately 37 miles north of Telluride via CO-62 and US-550",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good alternative for Ouray County and northern San Miguel County residents. About a 45-minute drive from Telluride with better road conditions in winter.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6hr drive to Denver each way", fpc: "No — ship from Telluride" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Remote Location", agency: "Telluride is 330+ miles from Denver — impractical trip", fpc: "No travel needed — we come to you via courier" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Assuming You Can Just Drive to Denver",
      description: "Telluride is 330 miles and 6+ hours from Denver. In winter, US-550 (Million Dollar Highway) and Red Mountain Pass can be treacherous or closed. There is simply no practical way to visit the Denver Passport Agency in a day. Our courier service is the only realistic option.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photos from Limited Local Options",
      description: "Telluride has very limited photo services. Make sure any photo taken meets strict State Department requirements — 2×2 inches on a pure white background, no shadows, no smiling, no glasses.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Planning Around Festival Seasons",
      description: "The Telluride Film Festival, Bluegrass Festival, Blues & Brews, and Mushroom Festival draw international crowds. Post office appointments become nearly impossible to book during these events. Plan passport needs well ahead of festival dates.",
    },
    {
      icon: "ri-snowflake-line",
      title: "Winter Road Closures",
      description: "US-550 over Red Mountain Pass and the Million Dollar Highway can close in winter storms. This cuts off Telluride from Montrose and Grand Junction. Don't count on being able to drive anywhere for passport services between November and April.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "European countries require 6 months of passport validity beyond your stay. Telluride's international crowd frequently travels to the Alps, Mediterranean, and South America — always check validity requirements well ahead.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Not Factoring TEX Airport Limitations",
      description: "Telluride Regional Airport (TEX) is a small regional airport with limited commercial service. Most international travel requires connections through Denver (DEN), Montrose (MTJ), or Grand Junction (GJT). Always verify your full itinerary's passport requirements.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Telluride or San Miguel County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at the UPS Store in Montrose or ship from Telluride." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — we catch the errors that remote mountain residents often miss." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no 6-hour Denver drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Telluride address — from the box canyon to the world." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Telluride, CO?", a: "Fast Passport Center offers emergency passport processing in Telluride, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — a critical service when Denver is 330 miles and 6 hours away." },
    { q: "Does Telluride have its own passport agency?", a: "No — Telluride does not have a regional passport agency. The nearest is the Denver Passport Agency (330 miles northeast — a 6+ hour drive each way). The Grand Junction post office can handle some passport services but is still 130 miles away. Fast Passport Center's courier service is essential for Telluride residents." },
    { q: "What airports serve Telluride for international travel?", a: "Telluride Regional Airport (TEX) offers limited domestic commercial service. Montrose Regional Airport (MTJ), 65 miles north, offers more connections. Most international travelers from Telluride connect through Denver International Airport (DEN), approximately 5.5 hours away by road." },
    { q: "Can you serve residents in Mountain Village, Placerville, and Norwood?", a: "Absolutely. Fast Passport Center serves all of San Miguel County including Mountain Village, Placerville, Norwood, and the surrounding communities. We also serve Ridgway, Ouray, Silverton, and the broader Western Slope region." },
    { q: "What if I'm in Telluride only for ski season?", a: "Fast Passport Center serves both full-time San Miguel County residents and seasonal residents. If you split your time between Telluride and another location, we can work with whichever address is most convenient for document delivery. Many of our clients are second-home owners and seasonal residents." },
    { q: "How much does an expedited passport cost in Telluride, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Given Telluride's remote location, our courier service provides exceptional value compared to the alternative of a 12-hour round trip to Denver." },
    { q: "Where can I get passport photos in Telluride?", a: "Options are limited in the Telluride area. Clark's Market (700 W Colorado Ave) may offer photo services. The UPS Store in Montrose (65 miles north) is the most reliable option. Always call ahead to confirm passport photo availability — this is a common challenge in remote mountain communities." },
    { q: "Does winter weather affect expedited passport service to Telluride?", a: "Winter weather can affect shipping to and from Telluride, but our system accounts for mountain weather delays. We recommend building in 1–2 extra buffer days during peak winter months (December–March). Our team monitors weather conditions and adjusts shipping routes as needed." },
  ],
  photoLocations: [
    { name: "Clark's Market — Telluride", address: "700 W Colorado Ave, Telluride, CO 81435", hours: "Mon–Sun: 7AM–9PM" },
    { name: "UPS Store — Montrose", address: "16450 S Townsend Ave, Montrose, CO 81401", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "Walgreens — Montrose", address: "16400 S Townsend Ave, Montrose, CO 81401", hours: "Mon–Sun: 8AM–9PM" },
    { name: "FedEx Office — Grand Junction", address: "2454 Highway 6 & 50, Grand Junction, CO 81505", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "DMV — Montrose (Montrose County)", address: "317 S 2nd St, Montrose, CO 81401", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for San Miguel and Montrose County residents. REAL ID and driver's license renewals. Approximately 65 miles from Telluride.", featured: true },
    { name: "DMV — Grand Junction (Mesa County)", address: "222 S 6th St, Grand Junction, CO 81501", hours: "Mon–Fri: 8AM–5PM", note: "Largest DMV on the Western Slope. REAL ID processing available. Approximately 130 miles from Telluride.", featured: false },
  ],
  airports: [
    {
      code: "TEX",
      name: "Telluride Regional Airport",
      distance: "5 miles west of Telluride via CO-145",
      address: "1500 Last Dollar Rd, Telluride, CO 81435",
      note: "Small regional airport at 9,070 feet — one of the highest commercial airports in North America. Limited domestic service. Most international travel requires connections through DEN or MTJ. Weather-dependent operations.",
      flightUrl: "https://www.tellurideairport.com/",
      flightLabel: "TEX Flight Info",
      featured: true,
    },
    {
      code: "MTJ",
      name: "Montrose Regional Airport",
      distance: "65 miles north of Telluride via CO-145 and US-550",
      address: "2100 Airport Rd, Montrose, CO 81401",
      note: "Primary regional airport for the Telluride area. Seasonal international flights available. Year-round domestic connections to DEN, DFW, PHX, and other major hubs. Approximately 1.5-hour drive from Telluride.",
      flightUrl: "https://www.montroseairport.com/",
      flightLabel: "MTJ Flight Info",
      featured: false,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "330 miles northeast of Telluride via US-550 and I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. 5.5–6 hour drive from Telluride. Nonstop flights to Europe, Asia, and the Americas. Most Telluride international travelers connect through DEN.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
  ],
};